import { memo, useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IntegrationAccount } from "app/pages/sales-intelligence/modules/company-analysis/types/crm-links";

import AccountsDropdown from "../AccountsDropdown/AccountsDropdown";

import { StyledSingleAccountTag } from "./styles";

export type SingleAccountTagProps = {
    account: IntegrationAccount;
    onAccountClick?: (account: IntegrationAccount) => void;
};

const SingleAccountTag = ({ account, onAccountClick }: SingleAccountTagProps) => {
    const accounts = useMemo(() => [account], [account]);
    const label = account.status || translate("si.account-overview.integration-tag.single-no-status");

    return (
        <AccountsDropdown
            accounts={accounts}
            ariaLabel={label}
            dataAutomationPrefix="integration-single-account"
            onAccountClick={onAccountClick}
        >
            <StyledSingleAccountTag>
                <span data-automation="integration-text">{label}</span>
            </StyledSingleAccountTag>
        </AccountsDropdown>
    );
};

export default memo(SingleAccountTag);
